import React, { useContext, useState } from 'react';
import { Button, TextField, Typography } from '@mui/material';
import { ArrowForwardIos, Cancel } from '@mui/icons-material';
import { useAppDispatch, useAppSelector } from '../../Store/hooks';
import { SelectStatus, SelectShipment } from '../../Store/Selectors';
import { loadCheckPostCode, setPostCode } from '../../Store/Slices';
import './PostCodeCheck.scss';

export const PostCodeChecker: React.FC = () => {
  const dispatch = useAppDispatch();
  const shipmentSearch = useAppSelector(SelectShipment);
  const statusState = useAppSelector(SelectStatus);
  const postCode = shipmentSearch.postCode;
  const isError = statusState.deliveredToDetails.info === 'Error' ? true : false;
  const ErrorClass = isError ? 'post-code-check-failed' : '';

  const [clearedPostCode, setClearedPostcode] = useState<boolean>(false);
  const checkPostCode = () => dispatch(loadCheckPostCode({ postCode, shipmentNumber: shipmentSearch.shipmentNumber }))

  const returnLogo = () => {
    if (isError && clearedPostCode) {
      return (
        <Button
          disabled={postCode.length < 5}
          color={'warning'}
          variant="contained"
          size="small"
          onClick={checkPostCode}>
          <ArrowForwardIos style={{ color: 'white' }} />
        </Button>
      );
    }

    if (isError) return <Cancel fontSize="large" />;

    return (
      <Button
        disabled={postCode.length < 5}
        variant="contained"
        size="small"
        onClick={checkPostCode}>
        <ArrowForwardIos />
      </Button>
    );
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') return checkPostCode();
    if (e.key === 'Backspace') {
      if (isError) {
        setClearedPostcode(true);
      }
    }
    return;
  };
  return (
    <div>
      <Typography variant="subtitle2" marginTop={1} marginBottom={1}>
        Für weitere Informationen geben Sie bitte die Empfanger-Postleitzahl ein:
      </Typography>
      <TextField
        className={`${ErrorClass}`}
        size={'small'}
        label="PLZ Empfänger"
        variant="outlined"
        value={postCode}
        color={isError ? 'warning' : 'primary'}
        disabled={shipmentSearch.postCodeCheckLoading === true}
        onChange={(e) => dispatch(setPostCode(e.target.value))}
        onKeyUp={(e) => handleKeyPress(e)}
        InputProps={{
          endAdornment: returnLogo()
        }}
      />
      {statusState?.deliveredToDetails?.label && (
        <>
          <Typography
            className="d-flex align-items-center"
            color={isError ? 'warning.main' : ''}
            variant="subtitle2"
            marginTop={1}
            marginBottom={0.5}>
            {!isError && <p className="me-1">&#10004;</p>} {`${statusState.deliveredToDetails?.label}`}
          </Typography>
        </>
      )}
    </div>
  );
};
